import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import admin from './modules/admin';
import adminRole from './modules/adminRole';
import adminResource from './modules/adminResource';
import adminPermission from './modules/adminPermission';
import membership from './modules/membership';
import consumeSetting from './modules/consumeSetting';
import internalSetting from './modules/internalSetting';
import membershipOrder from './modules/membershipOrder';
import topupOrder from './modules/topupOrder';
import propertyAd from './modules/propertyAd';
import projectAd from './modules/projectAd';
import crowdfund from './modules/crowdfund';
import investment from './modules/investment';
import broadcast from './modules/broadcast';
import member from './modules/member';
import chat from './modules/chat';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        auth,
        admin,
        adminRole,
        adminResource,
        adminPermission,
        membership,
        consumeSetting,
        chat,
        internalSetting,
        membershipOrder,
        topupOrder,
        propertyAd,
        projectAd,
        crowdfund,
        investment,
        broadcast,
        member
    },
    strict: debug
});
